import { authHeader } from "./auth-header";
export const getHeaders = (token) => {
  const headerSet = authHeader(token);
  return {
    authorization: headerSet.Authorization,
    "content-type": "application/json",
  };
};
